import type { LevelDefinition } from '../game/types';

const floor = { x: 240, y: 261, width: 480, height: 18, style: 'stone' as const };

export const LEVELS: LevelDefinition[] = [
  {
    id: 1,
    name: 'Kamienica Pod Żabami',
    subtitle: 'Portal przy placu Wojska Polskiego',
    fact: 'Secesyjną fasadę zdobią żaby we frakach oraz wielkie chrabąszcze.',
    theme: 'frog-house',
    music: 'secession',
    palette: [0x0a2435, 0x27504b, 0xd9c18d, 0xb86746],
    playerSpawns: [{ x: 72, y: 226 }, { x: 104, y: 226 }],
    platforms: [
      floor,
      { x: 112, y: 210, width: 104, style: 'awning' },
      { x: 292, y: 208, width: 120, style: 'stone' },
      { x: 210, y: 158, width: 94, style: 'wood' },
      { x: 390, y: 146, width: 104, style: 'awning' },
      { x: 68, y: 126, width: 92, style: 'stone' },
    ],
    enemies: [
      { x: 122, y: 185, kind: 'beetle', behavior: 'patrol', direction: 1 },
      { x: 293, y: 182, kind: 'beetle', behavior: 'patrol', direction: -1 },
      { x: 69, y: 102, kind: 'beetle', behavior: 'patrol', direction: 1 },
      { x: 392, y: 120, kind: 'beetle', behavior: 'hopper', coopOnly: true },
    ],
  },
  {
    id: 2,
    name: 'Plac Wojska Polskiego',
    subtitle: 'Secesyjne serce Białej',
    fact: 'Plac był dawnym rynkiem Białej i sąsiaduje z Kamienicą Pod Żabami.',
    theme: 'wojska-square',
    music: 'secession',
    palette: [0x12334a, 0x2c655d, 0xe5c990, 0xb85743],
    playerSpawns: [{ x: 66, y: 226 }, { x: 99, y: 226 }],
    platforms: [
      floor,
      { x: 95, y: 206, width: 116, style: 'awning' },
      { x: 265, y: 218, width: 92, style: 'stone' },
      { x: 405, y: 194, width: 92, style: 'awning' },
      { x: 188, y: 156, width: 112, style: 'stone' },
      { x: 354, y: 132, width: 108, style: 'wood' },
      { x: 63, y: 112, width: 82, style: 'stone' },
    ],
    enemies: [
      { x: 91, y: 180, kind: 'devil', behavior: 'hopper', direction: 1 },
      { x: 270, y: 192, kind: 'beetle', behavior: 'patrol', direction: -1 },
      { x: 188, y: 130, kind: 'devil', behavior: 'patrol', direction: 1 },
      { x: 356, y: 106, kind: 'beetle', behavior: 'patrol', direction: -1 },
      { x: 410, y: 168, kind: 'devil', behavior: 'hopper', coopOnly: true },
    ],
  },
  {
    id: 3,
    name: 'Rynek z Neptunem',
    subtitle: 'Fontanna budzi wodne psoty',
    fact: 'Na bielskim Rynku stoi fontanna Neptuna, a bruk skrywa ślady dawnego miasta.',
    theme: 'market',
    music: 'secession',
    palette: [0x193d58, 0x3b7770, 0xe8d5a4, 0x6bb6c9],
    playerSpawns: [{ x: 55, y: 226 }, { x: 88, y: 226 }],
    platforms: [
      floor,
      { x: 94, y: 202, width: 104, style: 'stone' },
      { x: 244, y: 222, width: 104, style: 'stone' },
      { x: 403, y: 202, width: 104, style: 'stone' },
      { x: 165, y: 154, width: 106, style: 'awning' },
      { x: 331, y: 142, width: 112, style: 'stone' },
      { x: 58, y: 112, width: 82, style: 'awning' },
    ],
    winds: [{ x: 220, y: 110, width: 48, height: 145, forceX: 0, forceY: -72, pulseMs: 2200 }],
    enemies: [
      { x: 95, y: 176, kind: 'fountain', behavior: 'hopper', direction: 1 },
      { x: 405, y: 176, kind: 'fountain', behavior: 'hopper', direction: -1 },
      { x: 164, y: 128, kind: 'beetle', behavior: 'patrol', direction: 1 },
      { x: 332, y: 116, kind: 'fountain', behavior: 'patrol', direction: -1 },
      { x: 58, y: 86, kind: 'devil', behavior: 'hopper', coopOnly: true },
    ],
  },
  {
    id: 4,
    name: 'Zamek Sułkowskich',
    subtitle: 'Nocna potyczka pod murami',
    fact: 'Zamek wyrósł na miejscu średniowiecznej warowni strzegącej szlaku handlowego.',
    theme: 'castle',
    music: 'secession',
    palette: [0x081c31, 0x324a58, 0xc7b889, 0xb75548],
    playerSpawns: [{ x: 58, y: 226 }, { x: 91, y: 226 }],
    platforms: [
      floor,
      { x: 92, y: 205, width: 116, style: 'stone' },
      { x: 248, y: 176, width: 116, style: 'stone' },
      { x: 404, y: 205, width: 116, style: 'stone' },
      { x: 87, y: 132, width: 102, style: 'wood' },
      { x: 390, y: 126, width: 106, style: 'wood' },
    ],
    enemies: [
      { x: 94, y: 180, kind: 'bandit', behavior: 'hopper', direction: 1 },
      { x: 402, y: 180, kind: 'bandit', behavior: 'hopper', direction: -1 },
      { x: 248, y: 150, kind: 'devil', behavior: 'patrol', direction: 1 },
      { x: 88, y: 106, kind: 'bandit', behavior: 'patrol', coopOnly: true },
      { x: 390, y: 100, kind: 'devil', behavior: 'hopper', coopOnly: true },
    ],
    boss: {
      name: 'Kamienny Psotnik',
      texture: 'stone-trickster',
      health: 2,
      x: 245,
      y: 228,
      relocationPoints: [{ x: 82, y: 178 }, { x: 399, y: 178 }, { x: 248, y: 145 }],
    },
  },
  {
    id: 5,
    name: 'Stara Fabryka',
    subtitle: 'Maszyny, nici i kłębki',
    fact: 'Bielskie fabryki włókiennicze przez dziesięciolecia napędzały rozwój miasta.',
    theme: 'factory',
    music: 'industrial',
    palette: [0x111d27, 0x30454b, 0xb78b54, 0xd55b3e],
    playerSpawns: [{ x: 55, y: 226 }, { x: 88, y: 226 }],
    platforms: [
      floor,
      { x: 102, y: 212, width: 136, style: 'metal' },
      { x: 290, y: 212, width: 130, style: 'metal' },
      { x: 430, y: 176, width: 76, style: 'metal' },
      { x: 206, y: 160, width: 116, style: 'metal' },
      { x: 62, y: 126, width: 86, style: 'metal' },
      { x: 357, y: 108, width: 116, style: 'metal' },
    ],
    winds: [{ x: 222, y: 60, width: 45, height: 190, forceX: 60, forceY: -18, pulseMs: 1600 }],
    enemies: [
      { x: 102, y: 186, kind: 'yarn', behavior: 'hopper', direction: 1 },
      { x: 292, y: 186, kind: 'yarn', behavior: 'patrol', direction: -1 },
      { x: 205, y: 134, kind: 'luggage', behavior: 'patrol', direction: 1 },
      { x: 357, y: 82, kind: 'yarn', behavior: 'hopper', direction: -1 },
      { x: 430, y: 150, kind: 'luggage', behavior: 'patrol', coopOnly: true },
    ],
  },
  {
    id: 6,
    name: 'Dworzec Główny',
    subtitle: 'Pompejańskie polichromie',
    fact: 'Budynek dworca z 1890 roku zachował w hali efektowne polichromie.',
    theme: 'station',
    music: 'industrial',
    palette: [0x15263a, 0x465765, 0xd6ad67, 0xa84d3e],
    playerSpawns: [{ x: 58, y: 226 }, { x: 91, y: 226 }],
    platforms: [
      floor,
      { x: 102, y: 205, width: 124, style: 'metal' },
      { x: 267, y: 218, width: 110, style: 'wood' },
      { x: 414, y: 198, width: 100, style: 'metal' },
      { x: 175, y: 153, width: 104, style: 'wood' },
      { x: 342, y: 142, width: 116, style: 'metal' },
      { x: 56, y: 104, width: 80, style: 'metal' },
    ],
    enemies: [
      { x: 102, y: 179, kind: 'luggage', behavior: 'patrol', direction: 1 },
      { x: 266, y: 192, kind: 'luggage', behavior: 'hopper', direction: -1 },
      { x: 175, y: 127, kind: 'yarn', behavior: 'hopper', direction: 1 },
      { x: 342, y: 116, kind: 'luggage', behavior: 'patrol', direction: -1 },
      { x: 56, y: 78, kind: 'devil', behavior: 'hopper', coopOnly: true },
      { x: 414, y: 172, kind: 'luggage', behavior: 'patrol', coopOnly: true },
    ],
  },
  {
    id: 7,
    name: 'Kolej na Szyndzielnię',
    subtitle: 'Ponad koronami drzew',
    fact: 'Gondole wspinają się nad lasem, łącząc miasto ze szlakami Beskidu Śląskiego.',
    theme: 'gondola',
    music: 'mountain',
    palette: [0x0b2841, 0x285847, 0x96b574, 0xe1b950],
    playerSpawns: [{ x: 55, y: 226 }, { x: 88, y: 226 }],
    platforms: [
      floor,
      { x: 95, y: 210, width: 112, style: 'wood' },
      { x: 252, y: 188, width: 98, style: 'cloud' },
      { x: 407, y: 213, width: 104, style: 'wood' },
      { x: 130, y: 143, width: 96, style: 'cloud' },
      { x: 334, y: 126, width: 112, style: 'cloud' },
      { x: 54, y: 92, width: 76, style: 'wood' },
    ],
    winds: [
      { x: 155, y: 50, width: 86, height: 188, forceX: 50, forceY: -25, pulseMs: 1800 },
      { x: 340, y: 50, width: 86, height: 188, forceX: -50, forceY: -25, pulseMs: 2400 },
    ],
    enemies: [
      { x: 95, y: 184, kind: 'wisp', behavior: 'flyer', direction: 1 },
      { x: 252, y: 162, kind: 'wisp', behavior: 'flyer', direction: -1 },
      { x: 407, y: 187, kind: 'bandit', behavior: 'hopper', direction: -1 },
      { x: 130, y: 117, kind: 'wisp', behavior: 'flyer', direction: 1 },
      { x: 334, y: 100, kind: 'wisp', behavior: 'flyer', coopOnly: true },
    ],
  },
  {
    id: 8,
    name: 'Szyndzielnia nocą',
    subtitle: 'Nocna potyczka pośród gwiazd',
    fact: 'Ze szczytu Szyndzielni rozciąga się panorama miasta i otaczających je Beskidów.',
    theme: 'summit',
    music: 'mountain',
    palette: [0x050d27, 0x152c4b, 0x507c72, 0xe6cc75],
    playerSpawns: [{ x: 58, y: 226 }, { x: 91, y: 226 }],
    platforms: [
      floor,
      { x: 92, y: 205, width: 116, style: 'stone' },
      { x: 243, y: 178, width: 112, style: 'cloud' },
      { x: 398, y: 205, width: 116, style: 'stone' },
      { x: 84, y: 125, width: 92, style: 'cloud' },
      { x: 398, y: 119, width: 92, style: 'cloud' },
    ],
    winds: [{ x: 80, y: 40, width: 320, height: 205, forceX: 65, forceY: -12, pulseMs: 1500 }],
    enemies: [
      { x: 92, y: 179, kind: 'wisp', behavior: 'flyer', direction: 1 },
      { x: 398, y: 179, kind: 'wisp', behavior: 'flyer', direction: -1 },
      { x: 84, y: 99, kind: 'devil', behavior: 'hopper', direction: 1 },
      { x: 398, y: 93, kind: 'wisp', behavior: 'flyer', coopOnly: true },
      { x: 243, y: 152, kind: 'bandit', behavior: 'hopper', coopOnly: true },
    ],
    boss: {
      name: 'Beskidzki Wicher',
      texture: 'mountain-wind',
      health: 3,
      x: 243,
      y: 225,
      relocationPoints: [{ x: 84, y: 98 }, { x: 398, y: 92 }, { x: 243, y: 151 }],
    },
  },
  {
    id: 9,
    name: 'Książnica Beskidzka',
    subtitle: 'Biblioteka przy ulicy Słowackiego',
    fact: 'Modernistyczną siedzibę Książnicy przy Słowackiego 17A oddano do użytku w 1973 roku.',
    theme: 'library',
    music: 'secession',
    palette: [0x172235, 0x394d59, 0xd7aa62, 0x7f9b77],
    playerSpawns: [{ x: 58, y: 226 }, { x: 91, y: 226 }],
    platforms: [
      floor,
      { x: 89, y: 208, width: 112, style: 'stone' },
      { x: 247, y: 220, width: 112, style: 'wood' },
      { x: 408, y: 198, width: 112, style: 'stone' },
      { x: 163, y: 157, width: 108, style: 'wood' },
      { x: 337, y: 139, width: 118, style: 'stone' },
      { x: 61, y: 111, width: 80, style: 'wood' },
    ],
    enemies: [
      { x: 89, y: 182, kind: 'yarn', behavior: 'patrol', direction: 1 },
      { x: 248, y: 194, kind: 'devil', behavior: 'hopper', direction: -1 },
      { x: 407, y: 172, kind: 'luggage', behavior: 'patrol', direction: -1 },
      { x: 163, y: 131, kind: 'wisp', behavior: 'flyer', direction: 1 },
      { x: 337, y: 113, kind: 'yarn', behavior: 'hopper', coopOnly: true },
      { x: 61, y: 85, kind: 'devil', behavior: 'patrol', coopOnly: true },
    ],
  },
  {
    id: 10,
    name: 'Bielskie Błonia',
    subtitle: 'Pumptrack u podnóża Koziej Góry',
    fact: 'Na Błoniach działają między innymi skatepark, pumptrack i boiska z widokiem na góry.',
    theme: 'blonia',
    music: 'mountain',
    palette: [0x173247, 0x365e3e, 0xa6bb63, 0xd8a34f],
    playerSpawns: [{ x: 55, y: 226 }, { x: 88, y: 226 }],
    platforms: [
      floor,
      { x: 96, y: 213, width: 118, style: 'stone' },
      { x: 257, y: 194, width: 112, style: 'wood' },
      { x: 411, y: 216, width: 106, style: 'stone' },
      { x: 154, y: 149, width: 108, style: 'cloud' },
      { x: 335, y: 137, width: 112, style: 'wood' },
      { x: 63, y: 98, width: 82, style: 'cloud' },
    ],
    winds: [
      { x: 190, y: 54, width: 72, height: 180, forceX: 42, forceY: -12, pulseMs: 2100 },
      { x: 356, y: 65, width: 65, height: 165, forceX: -35, forceY: -9, pulseMs: 2600 },
    ],
    enemies: [
      { x: 96, y: 187, kind: 'beetle', behavior: 'hopper', direction: 1 },
      { x: 257, y: 168, kind: 'bandit', behavior: 'hopper', direction: -1 },
      { x: 411, y: 190, kind: 'wisp', behavior: 'flyer', direction: -1 },
      { x: 154, y: 123, kind: 'beetle', behavior: 'patrol', direction: 1 },
      { x: 335, y: 111, kind: 'wisp', behavior: 'flyer', coopOnly: true },
      { x: 63, y: 72, kind: 'bandit', behavior: 'hopper', coopOnly: true },
    ],
  },
  {
    id: 11,
    name: 'Galeria Sfera',
    subtitle: 'Finał nad rzeką Białą',
    fact: 'Dwa budynki Sfery powstały na terenach dawnych fabryk włókienniczych i zachowały ich ślady.',
    theme: 'sfera',
    music: 'industrial',
    palette: [0x091b34, 0x254861, 0xb65d43, 0xe0ad57],
    playerSpawns: [{ x: 58, y: 226 }, { x: 91, y: 226 }],
    platforms: [
      floor,
      { x: 91, y: 205, width: 112, style: 'metal' },
      { x: 246, y: 221, width: 110, style: 'stone' },
      { x: 408, y: 202, width: 112, style: 'metal' },
      { x: 170, y: 157, width: 116, style: 'metal' },
      { x: 342, y: 139, width: 112, style: 'stone' },
      { x: 61, y: 108, width: 82, style: 'metal' },
    ],
    winds: [{ x: 218, y: 52, width: 52, height: 190, forceX: 0, forceY: -48, pulseMs: 1850 }],
    enemies: [
      { x: 91, y: 179, kind: 'luggage', behavior: 'patrol', direction: 1 },
      { x: 246, y: 195, kind: 'devil', behavior: 'hopper', direction: -1 },
      { x: 408, y: 176, kind: 'yarn', behavior: 'hopper', direction: -1 },
      { x: 170, y: 131, kind: 'luggage', behavior: 'patrol', direction: 1 },
      { x: 342, y: 113, kind: 'wisp', behavior: 'flyer', direction: -1 },
      { x: 61, y: 82, kind: 'devil', behavior: 'hopper', coopOnly: true },
      { x: 423, y: 235, kind: 'luggage', behavior: 'patrol', coopOnly: true },
    ],
  },
];

export const LEVEL_COUNT = LEVELS.length;

export function validateLevels(levels: LevelDefinition[] = LEVELS): string[] {
  const errors: string[] = [];
  if (levels.length !== LEVEL_COUNT) {
    errors.push(`Oczekiwano ${LEVEL_COUNT} plansz, otrzymano ${levels.length}.`);
  }

  levels.forEach((level, index) => {
    if (level.id !== index + 1) errors.push(`Plansza ${index + 1} ma błędne id ${level.id}.`);
    if (!level.name || !level.fact) errors.push(`Plansza ${level.id} nie ma nazwy lub faktu.`);
    if (level.platforms.length < 2) errors.push(`Plansza ${level.id} ma za mało platform.`);
    if (!level.platforms.some((platform) => platform.y >= 250)) {
      errors.push(`Plansza ${level.id} nie ma podłogi.`);
    }
    if (!level.enemies.some((enemy) => !enemy.coopOnly)) {
      errors.push(`Plansza ${level.id} nie ma przeciwnika w trybie solo.`);
    }
    for (const point of [...level.playerSpawns, ...level.enemies]) {
      if (point.x < 0 || point.x > 480 || point.y < 22 || point.y > 270) {
        errors.push(`Obiekt planszy ${level.id} leży poza ekranem.`);
      }
    }
    if (level.boss) {
      if (level.boss.relocationPoints.length < 3) {
        errors.push(`Boss planszy ${level.id} ma za mało stref przerzutu.`);
      }
      for (const point of level.boss.relocationPoints) {
        if (point.x < 30 || point.x > 450 || point.y < 40 || point.y > 235) {
          errors.push(`Strefa przerzutu bossa planszy ${level.id} leży poza bezpiecznym obszarem.`);
        }
      }
    }
  });

  return errors;
}
